import { GET } from './config';
import regeneratorRuntime from "regenerator-runtime";
import { multicanalMascota } from '../../properties';

const MASCOTAS_COTIZADORES = multicanalMascota.imagenes;

/**
 * Autor: Benigno Alvarado Rodríguez
 * Descripción: Metodo para la descarga de archivo tipo blob
 * @param {boolean} type - Se manda true para indicar que la peticion contiene un dato blob
 * @param {object} respond  - Se manda el un objeto
 */
 const TYPE_BODY = ( type, respond ) => {
    if( type ) { // Es un archivo blob
        return respond.blob();
    }else {
        const contentType = respond.headers.get("content-type");
        if(contentType && contentType.indexOf("application/json") !== -1) {
            return respond.json(); // Tiene datos a usar del response
        } else {
            return respond; // NO tiene datos a usar
        }
    }
}

/**
 * Autor: Benigno Alvarado Rodríguez
 * Descripción: Metodo global para peticiones rest a través de fetch
 * @ endPoint: Es el end point del api a solicitar
 * @ verb: Es el tipo HTTP a utilizar
 */
 const REST_API = async ( endPoint, verb, type = false ) => {
    try {
        const respond = await fetch( endPoint, verb );

        if( respond.status !== 200 && respond.status !== 201  ) {
            let result = { ok: false }
            if( respond.status === 403 ) {
                const {status, message } = await respond.json();
                result = { status, message, ok: false };
            }else {
                const {status, message } = await respond.json();
                result = { status, message, ok: false };
            }
            return result;
        }
        return TYPE_BODY( type, respond );

    } catch( error ) {
        return { ok: false, message: 'Service fail' };
    }
};

/**
 * Autor: Benigno Alvarado Rodríguez
 * Descripción: Metodo para ingresar datos tipo POST con JWT
 */
export const getData = ( endPoint, body ) => {
    return REST_API( `${ MASCOTAS_COTIZADORES }${ endPoint }${body}`, GET() );
}



// WEBPACK FOOTER //
// ./src/functions/rest-api/index.js